import { Code, DataList, Dialog } from "@chakra-ui/react";

const InfoModal = ({ type, listToRender, open, setOpen }) => {
  return (
    <Dialog.Root
      size="xs"
      placement="center"
      motionPreset="scale"
      open={open}
      onOpenChange={(e) => {
        setOpen(e.open);
      }}
    >
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content>
          <Dialog.Header textAlign="center">
            <Dialog.Title>{type} Info</Dialog.Title>
            <Dialog.CloseTrigger />
          </Dialog.Header>
          <Dialog.Body>
            <DataList.Root orientation="horizontal" divideY="1px" maxW="md">
              {listToRender?.map((item) => (
                <DataList.Item key={item.label} pt="4">
                  <DataList.ItemLabel width="40%" fontSize="xs">
                    {item?.label}
                  </DataList.ItemLabel>
                  <DataList.ItemValue fontSize="xs">{item?.value}</DataList.ItemValue>
                </DataList.Item>
              ))}
            </DataList.Root>
          </Dialog.Body>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
};

export default InfoModal;
